module Meevo.Plugins.Sandbox {
    import Sandbox = Meevo.Model.ISandbox;
    import SandboxProcessQueue = Meevo.Model.ISandboxProcessQueue;

    interface ISandboxService {
        getSandbox(): ng.IPromise<Sandbox>;
        createSandbox(): ng.IPromise<Sandbox>;
        getProcessQueue(): ng.IPromise<SandboxProcessQueue>;
        sandboxExist(): ng.IPromise<boolean>;
        refreshSandbox(): ng.IPromise<any>;
        cancelRefreshSandbox(processQueue: SandboxProcessQueue): ng.IPromise<any>;
    }

    export class SandboxService implements ISandboxService {

        constructor(
            private $q: ng.IQService,
            private $http: ng.IHttpService,
            private appSettings: Meevo.Components.Common.IAppSettings
        ) { }

        /**
         * Get sandbox
         */
        public getSandbox(): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox`;

            return this.$http.get(url).then((response) => {
               return response.data;
            });;
        }

        /**
         * Create sandbox 
         */
        public createSandbox(): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox/ProcessQueue/Create`;

            return this.$http.post(url, {}).then((response) => {
                return response.data;
            });;
        }

        /**
         * Get list of process
         */
        public getProcessQueue(): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox/ProcessQueue/List`;

            return this.$http.get(url).then((response) => {
                return response.data;
            });;
        }

        /**
         * Check if sandbox exist
         */
        public sandboxExist(): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox/ProcessQueue/Count`;

            return this.$http.get(url).then((response) => {
                return response.data;
            });;
        }

        /**
         * Refresh Sandbox
         */
        public refreshSandbox(): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox/ProcessQueue/Refresh`;

            return this.$http.post(url, {}).then((response) => {
                return response.data;
            });;
        }

        /**
         * Cancel Refresh
         */
        public cancelRefreshSandbox(processQueue: SandboxProcessQueue): ng.IPromise<any> {
            let url = `/${this.appSettings.API_ROOT}/Sandbox/ProcessQueue/${processQueue.id}/Cancel`;

            return this.$http.patch(url, { ProcessId: processQueue.id}).then((response) => {
                return response.data;
            });;
        }

        static factory(): Function {
            let svc = ($q: ng.IQService, $http: ng.IHttpService, appSettings: Meevo.Components.Common.IAppSettings) => {
                return new SandboxService($q, $http, appSettings);
            }

            svc.$inject = [
                '$q',
                '$http',
                'meevo.AppSettings'
            ];
            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevo.plugins.sandbox.SandboxService", SandboxService.factory());
}
